module.exports = __webpack_public_path__ + "img/49.90adba0c.jpg";